import { Map } from 'immutable';

const notificationFromId = (state, id) =>
  state.entities.getIn(['notifications', id.toString()], Map());

const notificationsFromIds = (state, ids) =>
  ids.map(id => notificationFromId(state, id))
     .sortBy(item => item.get('posted_on'))
     .reverse();

const allNotifications = (state) =>
  notificationsFromIds(state, state.notifications.ids);

const unreadNotifications = (state) =>
  allNotifications(state).filter(item => !item.get('is_read'));

export const getNotifications = (state) =>
  allNotifications(state).toJS();

export const getUnreadNotificationCount = (state) =>
  unreadNotifications(state).count();



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/notifications.js